export enum InputSettingsDropdownOptions {
  SetAsNull = 'setAsNull',
  EditValue = 'editValue'
}
